// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-block-title[data-v-7d8229f9] {\n  margin: 15px 15px 10px;\n}", "",{"version":3,"sources":["webpack://./src/pages/accounts/CMAccountMembersPage/CMAccountMembersList.vue"],"names":[],"mappings":"AACA;EACE,sBAAA;AAAF","sourcesContent":["\n.content-block-title {\n  margin: 15px 15px 10px\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
